<p-dialog header="Tax" [modal]="true" [(visible)]="visible" [style]="{ width: '60vw' }">
  <div class="card">
      <p-table [value]="taxes" dataKey="uId" responsiveLayout="scroll" selectionMode="multiple" [(selection)]="selectedTax">
          <ng-template pTemplate="header">
              <tr>
                  <th>Name</th>
                  <th>Country</th>
                  <th>State/Province</th>
                  <th>Zipcode</th>
                  <th>Product Category</th>
                  <th>Tax Rate</th>
              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-tax>
              <tr [pSelectableRow]="tax">
                  <td>{{ tax?.name ?? ''}}</td>
                  <td>{{ tax?.country ?? ''}}</td>
                  <td>{{ tax?.state ?? ''}}</td>
                  <td>{{ tax?.zipCode ?? ''}}</td>
                  <td>{{ tax?.categories ?? ''}}</td>
                  <td>{{ tax?.taxRate ?? ''}}</td>
              </tr>
          </ng-template>
      </p-table>
  </div>
  <ng-template pTemplate="footer">
      <p-button (click)="onCloseDialog()" label="Cancel" styleClass="p-button-secondary"></p-button>
      <p-button label="Apply" (click)="applyTax()"></p-button>
  </ng-template>
</p-dialog>
